// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/stylesheets/animations.css
// module id = 3
// module chunks = 0